var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"leaflet-popup-body\">\n  <div class=\"leaflet-popup-header\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Name") : depth0), depth0))
    + "</div>\n  <div class=\"leaflet-popup-fuel-station\">\n    <div class=\"item\">\n      <span class=\"leaflet-popup-label\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Common.Brand",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":5,"column":40},"end":{"line":5,"column":63}}}))
    + ":</span>\n      <span class=\"leaflet-popup-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"NameBrand") : depth0), depth0))
    + "</span>\n    </div>\n    <div class=\"item\">\n      <span class=\"leaflet-popup-label\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Common.CompanyName",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":9,"column":40},"end":{"line":9,"column":69}}}))
    + ":</span>\n      <span class=\"leaflet-popup-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Name") : depth0), depth0))
    + "</span>\n    </div>\n  </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-farm-machine-popup.hbs
// module id = mkjy
// module chunks = 1